export const gallery = {
  title: "La vida en Gándara",
  subtitle: "Un espacio donde crecer, explorar y descubrir"
};
